
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import Multiselect from 'vue-multiselect';
  
  @Component({
    components: {
      Multiselect
    }
  })
  export default class FormMultiselect extends Vue {
    @Prop({ default: null }) readonly value!: any[];
    @Prop({ default: () => [] }) readonly options!: any[];
    @Prop({ type: String, default: '' }) readonly name!: string;
    @Prop({ type: String, default: 'Select option' }) readonly placeholder!: string;
    @Prop({ type: Function, default: null }) readonly search!: (
      search: string,
      loading: (loading: boolean) => void
    ) => void;
  
    internalValue = this.value;
    internalIsLoading = false;
  
    @Watch('value', { immediate: true })
    onValueChange(newValue: any[]) {
      this.internalValue = newValue;
    }
  
    updateValue(newValue: any[]): void {
      this.$emit('input', newValue);
    }
  
    handleSearch(searchTerm: string) {
      if (this.search) {
        this.search(searchTerm, (loading: boolean) => {
          this.internalIsLoading = loading;
        });
      }
    }
  
    handleClose() {
      this.$emit('close');
    }
  }
  